import * as pageTools from '@qompium/pages-helper-tools';

export async function get<T>(url: string, endpoint?: string | undefined) {
  return await resolve<T>(pageTools.get(url, endpoint));
}

export async function getList<T>(url: string, endpoint?: string | undefined) {
  return await resolveList<T>(pageTools.get(url, endpoint));
}

export async function getFirst<T>(url: string, endpoint?: string | undefined) {
  const result = await resolveList<T>(pageTools.get(url, endpoint));

  return result[0];
}

export async function getAll<T>(url: string, endpoint?: string | undefined) {
  return await resolve<T>(pageTools.getAll(url, endpoint));
}

export async function put<T>(url: string, endpoint?: string | undefined, data?: any) {
  return await resolve<T>(pageTools.put(url, endpoint, data));
}

export async function post<T>(url: string, endpoint?: string | undefined, data?: any) {
  return await resolve<T>(pageTools.post(url, endpoint, data));
}

async function resolve<T>(httpCall: Promise<any>): Promise<T | undefined> {
  return await httpCall;
}

async function resolveList<T>(httpCall: Promise<any>): Promise<T[]> {
  return (await httpCall).data;
}
